if (!customElements.get('sms-signup-form')) {
  customElements.define(
    'sms-signup-form',
    class SmsSignupForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.phone = this.querySelector('input[name="phone"]');
        this.firstName = this.querySelector('input[name="first_name"]');
        this.consent = this.querySelector('input[name="consent"]');
        this.button = this.querySelector('button[type="submit"]');
        this.status = this.querySelector('[role="status"]');

        if (!this.form || this.form.dataset.smsSignupReady === 'true') return;

        this.form.dataset.smsSignupReady = 'true';
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }

      showStatus(message, type) {
        this.status.textContent = message;
        this.status.classList.toggle('sms-signup__status--success', type === 'success');
        this.status.classList.toggle('sms-signup__status--error', type === 'error');
        this.status.hidden = false;
        this.status.focus({ preventScroll: true });
      }

      async handleSubmit(event) {
        event.preventDefault();

        const phone = this.phone.value.trim();
        const firstName = this.firstName.value.trim();

        if (!phone) {
          this.showStatus('Please enter your phone number.', 'error');
          this.phone.focus();
          return;
        }

        if (!firstName) {
          this.showStatus('Please enter your first name.', 'error');
          this.firstName.focus();
          return;
        }

        if (!this.consent.checked) {
          this.showStatus('Please check the consent box to sign up.', 'error');
          this.consent.focus();
          return;
        }

        const backendUrl = (this.dataset.backendUrl || '').replace(/\/+$/, '');
        if (!backendUrl) {
          this.showStatus('Text signup is temporarily unavailable. Please try again later.', 'error');
          return;
        }

        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.status.hidden = true;

        try {
          const response = await fetch(`${backendUrl}/subscribe`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              phone,
              first_name: firstName,
              consent: true,
            }),
          });

          if (!response.ok) throw new Error('Subscribe request failed');

          this.form.reset();
          this.showStatus('Check your phone to confirm! Reply YES to the text.', 'success');
        } catch (error) {
          this.showStatus('We could not start your signup. Please check your number and try again.', 'error');
        } finally {
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }
      }
    },
  );
}
